import * as api from '../../api/store/actions';
import * as t from './action_types';

const INITIAL_STATE = {
    username: '',
    displayName: '',
    isLoaded: false,
    validateCheckComplete: false,
    authorizations: [],
    resetPasswordToken: '',
};

const accountReducer = (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case t.SET_ACCOUNT_DATA: {
            const { data } = action.payload;
            return {
                ...state,
                ...data,
                validateCheckComplete: true,
            };
        }
        case t.RESET_ACCOUNT_DATA: {
            return {
                ...INITIAL_STATE,
                //validateCheckComplete: false, // this is true b/c logout implies that we need new validation
            };
        }
        case t.SET_RESET_PASSWORD_TOKEN: {
            const { token } = action.payload;
            return {
                ...state,
                resetPasswordToken: token,
            };
        }
        case t.CLEAR_RESET_PASSWORD_TOKEN: {
            return {
                ...state,
                resetPasswordToken: '',
            };
        }
        case api.API_START: {
            if (action.payload.label === t.FETCH_ACCOUNT_DATA) {
                return {
                    ...state,
                    isLoadingUser: true,
                    validateCheckComplete: false,
                };
            }
        }
        case api.API_END: {
            if (action.payload.label === t.FETCH_ACCOUNT_DATA) {
                return {
                    ...state,
                    isLoadingUser: false,
                    //validateCheckComplete: true,
                };
            }
        }
        default:
            return state;
    }
};

export default accountReducer;
